import { Building2, Star } from 'lucide-react';

function LinkedinSvg({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect width="4" height="12" x="2" y="9" />
      <circle cx="4" cy="4" r="2" />
    </svg>
  );
}
import { useDocumentTitle } from '@/shared/hooks/use-document-title';

interface TeamMember {
  nombre: string;
  cargo: string;
  descripcion: string;
  imagen: string;
  linkedin?: string;
  especialidad?: string;
  experiencia?: string;
}

const LIDERAZGO_APEPS: TeamMember[] = [
  {
    nombre: 'Eduardo Andrés Morón Pastor',
    cargo: 'Presidente Independiente',
    descripcion:
      'Presidente de la Asociación Peruana de Entidades Prestadoras de Salud. Líder en la dirección estratégica de APEPS, promoviendo el desarrollo del sector salud privado y las políticas públicas que beneficien a los afiliados.',
    imagen: '/logo-apeps-cuadrado.png',
    linkedin: 'https://www.linkedin.com/in/eduardo-mor%C3%B3n-7454115/',
    experiencia: 'Presidente APEPS',
  },
  {
    nombre: 'Alfredo Antonio Sobrevilla Ricci',
    cargo: 'Director Gerente General',
    descripcion:
      'Gerente General de APEPS, responsable de la gestión operativa y administrativa de la asociación. Coordina las actividades del consejo directivo y supervisa la implementación de las estrategias organizacionales.',
    imagen: '/logo-apeps-cuadrado.png',
    linkedin: 'https://www.linkedin.com/in/alfredo-sobrevilla-16991312a/',
    experiencia: 'Gerente General APEPS',
  },
];

const CONSEJO_DIRECTIVO: TeamMember[] = [
  {
    nombre: 'Pablo Andrés Jackson Alvarado',
    cargo: 'Director por Mapfre Perú EPS',
    descripcion:
      'Miembro del Consejo Directivo de APEPS en representación de Mapfre EPS. Aporta su experiencia en gestión de seguros de salud y desarrollo de productos innovadores para el sector.',
    imagen: '/mapfre.png',
    experiencia: 'Mapfre EPS',
  },
  {
    nombre: 'Francisco Javier Monge Zegarra',
    cargo: 'Director por Pacífico EPS',
    descripcion:
      'Representante de Pacífico EPS en el Consejo Directivo de APEPS. Aporta su experiencia en el sector asegurador en salud y contribuye al desarrollo estratégico de las EPS en el Perú.',
    imagen: '/pacifico.png',
    experiencia: 'Pacífico EPS',
  },
  {
    nombre: 'Silvana Sarabia Quiroz',
    cargo: 'Director por Rímac EPS',
    descripcion:
      'Miembro del Consejo Directivo representando a Rímac EPS. Contribuye con su experiencia en la gestión de servicios de salud y el fortalecimiento del sector asegurador peruano.',
    imagen: '/rimac.png',
    experiencia: 'Rímac EPS',
  },
  {
    nombre: 'Carlos Alfredo Chavarriaga Ceballos',
    cargo: 'Director por Sanitas Perú EPS',
    descripcion:
      'Representante de Sanitas Perú EPS en el Consejo Directivo. Especialista en gestión de calidad asistencial y desarrollo de redes de prestadores de servicios de salud.',
    imagen: '/sanitas.png',
    experiencia: 'Sanitas Perú EPS',
  },
  {
    nombre: 'Luis Breña Mollehuara',
    cargo: 'Director por La Positiva EPS',
    descripcion:
      'Miembro del Consejo Directivo en representación de La Positiva EPS. Aporta su experiencia en la gestión del sector salud y en el desarrollo de iniciativas que beneficien a los afiliados del sistema EPS.',
    imagen: '/positiva.png',
    experiencia: 'La Positiva EPS',
  },
];

const DIRECTORES_ALTERNOS: TeamMember[] = [
  {
    nombre: 'Jorge Eduardo Gómez Milla',
    cargo: 'Director Alterno por Mapfre Perú EPS',
    descripcion:
      'Miembro del Consejo Directivo de APEPS en representación de Mapfre EPS. Aporta su experiencia en gestión de seguros de salud y desarrollo de productos innovadores para el sector.',
    imagen: '/mapfre.png',
    experiencia: 'Mapfre Perú EPS',
  },
  {
    nombre: 'Bernardo Javier Klinge León',
    cargo: 'Director Alterno por Mapfre Perú EPS',
    descripcion:
      'Director Alterno en representación de Mapfre Perú EPS. Contribuye con su experiencia en la gestión de seguros de salud al fortalecimiento del Consejo Directivo.',
    imagen: '/mapfre.png',
    experiencia: 'Mapfre Perú EPS',
  },
  {
    nombre: 'Rodolfo Jesús Grados Flores',
    cargo: 'Director Alterno por Rímac EPS',
    descripcion:
      'Director Alterno en representación de Rímac EPS. Aporta su experiencia en la gestión de servicios de salud y en el desarrollo del sector EPS en el Perú.',
    imagen: '/rimac.png',
    experiencia: 'Rímac EPS',
  },
  {
    nombre: 'Vanessa Toribio Reyes',
    cargo: 'Director Alterno por La Positiva EPS',
    descripcion:
      'Directora Alterna en representación de La Positiva EPS. Apoya las iniciativas del Consejo Directivo orientadas al fortalecimiento del aseguramiento en salud.',
    imagen: '/positiva.png',
    experiencia: 'La Positiva EPS',
  },
  {
    nombre: 'Ann Jennyfer Masgo Ramírez',
    cargo: 'Director Alterno por La Positiva EPS',
    descripcion:
      'Directora Alterna en representación de La Positiva EPS. Contribuye con su experiencia en el sector salud al desarrollo estratégico de APEPS.',
    imagen: '/positiva.png',
    experiencia: 'La Positiva EPS',
  },
  {
    nombre: 'Carlos Max Uribe Ríos',
    cargo: 'Director Alterno por Sanitas Perú EPS',
    descripcion:
      'Director Alterno en representación de Sanitas Perú EPS. Aporta su experiencia en la gestión de prestadores de servicios de salud y en el desarrollo del sector EPS.',
    imagen: '/sanitas.png',
    experiencia: 'Sanitas Perú EPS',
  },
  {
    nombre: 'Bibiana María García Guarín',
    cargo: 'Director Alterno por Sanitas Perú EPS',
    descripcion:
      'Directora Alterna en representación de Sanitas Perú EPS. Contribuye con su experiencia en la calidad asistencial y la gestión del sistema EPS.',
    imagen: '/sanitas.png',
    experiencia: 'Sanitas Perú EPS',
  },
  {
    nombre: 'Marco Antonio Heredia La Fuente',
    cargo: 'Director Alterno por Pacífico EPS',
    descripcion:
      'Director Alterno en representación de Pacífico EPS. Apoya al Consejo Directivo con su experiencia en el sector asegurador y la gestión de servicios de salud.',
    imagen: '/pacifico.png',
    experiencia: 'Pacífico EPS',
  },
];

function TeamCard({ member }: { member: TeamMember }): React.ReactElement {
  return (
    <div className="group relative overflow-hidden rounded-3xl border border-white/50 bg-white/80 shadow-xl backdrop-blur-xl transition-all duration-700 ease-out hover:-translate-y-2 hover:scale-105 hover:rotate-1 hover:shadow-2xl">
      {/* Fondo con gradientes animados */}
      <div className="from-primary/5 to-primary/5 absolute inset-0 bg-linear-to-br via-white/20 opacity-0 transition-all duration-700 group-hover:opacity-100" />
      <div className="absolute inset-0 bg-linear-to-tr from-transparent via-white/10 to-transparent opacity-0 transition-all duration-700 group-hover:opacity-100" />

      {/* Efecto de luz superior */}
      <div className="from-primary via-primary to-secondary absolute top-0 left-0 h-1 w-full origin-left scale-x-0 bg-linear-to-r opacity-0 transition-all duration-700 group-hover:scale-x-100 group-hover:opacity-100" />

      <div className="relative z-10 p-8">
        {/* Imagen del miembro */}
        <div className="mb-6 flex justify-center">
          <div className="group/img relative h-32 w-32">
            <div className="from-primary to-primary/80 absolute inset-0 scale-0 rounded-full bg-linear-to-br opacity-20 transition-all duration-700 ease-out group-hover:scale-110" />
            <img
              src={member.imagen}
              alt={`Foto de ${member.nombre}`}
              className="group-hover:border-primary/30 relative h-full w-full rounded-full border-4 border-white/70 object-cover shadow-2xl transition-all duration-500 group-hover:scale-110 group-hover:rotate-3"
              loading="lazy"
            />
            {/* Efecto de brillo */}
            <div className="absolute inset-0 rounded-full bg-linear-to-tr from-transparent via-white/30 to-transparent opacity-0 transition-all duration-500 group-hover:opacity-100" />
            {/* Indicador de estado */}
            <div className="bg-success absolute right-2 bottom-2 h-6 w-6 animate-pulse rounded-full border-3 border-white shadow-lg" />
          </div>
        </div>

        {/* Información principal */}
        <div className="mb-6 text-center">
          <h3 className="from-primary via-primary to-secondary mb-2 bg-linear-to-r bg-clip-text text-2xl font-bold text-transparent transition-colors duration-300">
            {member.nombre}
          </h3>
          <p className="text-primary group-hover:text-primary mb-3 text-lg font-semibold transition-colors duration-300">
            {member.cargo}
          </p>
          <div className="from-primary to-primary/80 mx-auto h-1 w-16 origin-center scale-x-0 rounded-full bg-linear-to-r transition-transform duration-500 group-hover:scale-x-100" />
        </div>

        {/* Descripción */}
        <p className="text-muted-foreground group-hover:text-foreground mb-6 text-center leading-relaxed transition-colors duration-300">
          {member.descripcion}
        </p>

        {/* Información adicional */}
        {(member.especialidad || member.experiencia) && (
          <div className="mb-6 space-y-3">
            {member.especialidad && (
              <div className="text-muted-foreground flex items-center justify-center space-x-2 text-sm">
                <Building2 className="h-4 w-4" />
                <span className="font-medium">{member.especialidad}</span>
              </div>
            )}
            {member.experiencia && (
              <div className="text-muted-foreground flex items-center justify-center space-x-2 text-sm">
                <Star className="h-4 w-4" />
                <span>{member.experiencia}</span>
              </div>
            )}
          </div>
        )}

        {/* Enlaces de contacto */}
        {member.linkedin && (
          <div className="flex justify-center space-x-4">
            <a
              href={member.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="group/btn border-primary/20 bg-primary/10 relative flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border shadow-lg backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:scale-110 hover:rotate-3 hover:shadow-2xl"
              title={`Ver perfil de LinkedIn de ${member.nombre}`}
            >
              <div className="from-primary to-primary/80 absolute inset-0 bg-linear-to-br opacity-0 transition-all duration-300 group-hover/btn:opacity-100" />
              <LinkedinSvg className="text-primary relative z-10 h-5 w-5 transition-all duration-300 group-hover/btn:text-white" />
            </a>
          </div>
        )}
      </div>

      {/* Efecto de partículas en hover */}
      <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-700 group-hover:opacity-30">
        <div className="bg-primary/50 absolute top-1/4 left-1/4 h-2 w-2 animate-pulse rounded-full" />
        <div className="bg-primary/50 absolute top-3/4 right-1/3 h-1.5 w-1.5 animate-pulse rounded-full delay-300" />
        <div className="bg-accent/50 absolute top-1/2 right-1/4 h-2.5 w-2.5 animate-pulse rounded-full delay-700" />
        <div className="bg-primary/40 absolute bottom-1/3 left-1/3 h-1 w-1 animate-pulse rounded-full delay-1000" />
      </div>
    </div>
  );
}

export function QuienesSomosPage(): React.ReactElement {
  useDocumentTitle('Quiénes Somos');

  return (
    <main className="min-h-screen pt-14">
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-24 pb-12">
        {/* Fondo con gradientes dinámicos */}
        <div className="from-primary/5 via-primary/5 to-secondary/5 absolute inset-0 bg-linear-to-br" />
        <div className="from-primary/10 to-secondary/10 absolute inset-0 bg-linear-to-tr via-transparent" />
        <div className="via-primary/5 to-primary/5 absolute inset-0 bg-linear-to-bl from-transparent" />

        {/* Efectos de partículas flotantes */}
        <div className="absolute inset-0 opacity-40">
          <div
            className="bg-primary/50 absolute top-1/4 left-1/4 h-4 w-4 animate-bounce rounded-full"
            style={{ animationDelay: '0s', animationDuration: '3s' }}
          />
          <div
            className="bg-primary/50 absolute top-3/4 right-1/3 h-3 w-3 animate-bounce rounded-full"
            style={{ animationDelay: '1s', animationDuration: '2.5s' }}
          />
          <div
            className="bg-secondary/50 absolute top-1/2 left-1/2 h-5 w-5 animate-bounce rounded-full"
            style={{ animationDelay: '0.5s', animationDuration: '3.5s' }}
          />
          <div
            className="bg-primary/40 absolute top-1/3 right-1/4 h-2 w-2 animate-bounce rounded-full"
            style={{ animationDelay: '1.5s', animationDuration: '2s' }}
          />
        </div>

        <div className="relative z-10 container mx-auto px-4 text-center">
          <div className="mx-auto max-w-5xl">
            {/* Badge superior */}
            <div className="group border-primary/20 mb-12 inline-flex transform items-center space-x-3 rounded-full border bg-white/90 px-8 py-4 shadow-2xl backdrop-blur-2xl transition-all duration-500 hover:scale-105">
              <div className="relative">
                <div className="from-primary to-secondary h-4 w-4 animate-pulse rounded-full bg-linear-to-r" />
                <div className="from-primary to-secondary absolute inset-0 h-4 w-4 animate-ping rounded-full bg-linear-to-r opacity-75" />
              </div>
              <span className="from-primary via-primary to-secondary bg-linear-to-r bg-clip-text text-base font-bold text-transparent">
                Conoce Nuestra Organización
              </span>
            </div>

            {/* Título principal */}
            <h1 className="text-foreground mb-8 text-4xl leading-tight font-bold md:text-5xl lg:text-7xl">
              <span className="from-primary via-primary to-secondary bg-linear-to-r bg-clip-text text-transparent">
                ¿Quiénes
              </span>
              <br />
              <span className="from-secondary via-primary to-primary bg-linear-to-r bg-clip-text text-transparent">
                Somos?
              </span>
            </h1>

            {/* Descripción principal */}
            <p className="text-muted-foreground mx-auto mb-12 max-w-4xl text-lg leading-relaxed md:text-xl">
              Conoce la historia, misión y visión de APEPS, la organización que representa a las
              principales{' '}
              <span className="text-foreground font-semibold">Entidades Prestadoras de Salud</span>{' '}
              del Perú.
            </p>
          </div>
        </div>
      </section>

      {/* Sección ¿Quiénes Somos? - Contenido principal */}
      <section className="relative overflow-hidden py-20">
        <div className="via-primary/5 absolute inset-0 bg-linear-to-b from-white to-white" />

        <div className="relative z-10 container mx-auto px-4">
          <div className="mx-auto max-w-6xl">
            <div className="mb-16 rounded-3xl border border-white/60 bg-white/90 p-8 shadow-2xl backdrop-blur-xl md:p-12">
              {/* Encabezado de la sección */}
              <div className="mb-12 text-center">
                <div className="bg-primary/10 mb-6 inline-flex items-center space-x-2 rounded-full px-6 py-3 backdrop-blur-sm">
                  <div className="bg-primary h-3 w-3 animate-pulse rounded-full" />
                  <span className="text-primary font-semibold">Nuestra Historia</span>
                </div>
                <h2 className="text-foreground mb-6 text-4xl font-bold md:text-5xl">
                  La Asociación de{' '}
                  <span className="from-primary to-secondary bg-linear-to-r bg-clip-text text-transparent">
                    EPS (APEPS)
                  </span>
                </h2>
              </div>

              {/* Contenido del texto */}
              <div className="text-foreground space-y-8 text-base leading-relaxed">
                <div className="mb-12 grid items-center gap-12 md:grid-cols-2">
                  <div className="space-y-6">
                    <p className="text-lg leading-relaxed">
                      La <strong className="text-primary">Asociación de EPS (APEPS)</strong>, es una
                      organización gremial privada que reúne a las principales Entidades Prestadoras
                      de Salud (EPS) de Perú, que son:{' '}
                      <span className="text-secondary font-semibold">
                        Pacífico, Rímac, Mapfre, Sanitas y La Positiva
                      </span>
                    </p>

                    <p className="text-lg">
                      La APEPS se desenvuelve en un sector con mucho potencial de crecimiento por la
                      demanda existente y la calidad de atención que presta la Seguridad Social en
                      Salud, aunque ello está sujeto al crecimiento de la economía y la
                      formalización laboral.
                    </p>
                  </div>

                  {/* Logos de las EPS */}
                  <div className="grid grid-cols-2 gap-4">
                    {[
                      { src: '/pacifico.png', alt: 'Pacífico EPS' },
                      { src: '/rimac.png', alt: 'Rímac EPS' },
                      { src: '/mapfre.png', alt: 'Mapfre EPS' },
                      { src: '/sanitas.png', alt: 'Sanitas EPS' },
                    ].map(eps => (
                      <div
                        key={eps.alt}
                        className="border-border/50 flex h-28 transform items-center justify-center overflow-hidden rounded-2xl border bg-white/50 backdrop-blur-sm transition-all duration-300 hover:scale-105"
                      >
                        <img
                          src={eps.src}
                          alt={eps.alt}
                          className="h-full w-full scale-150 object-contain"
                        />
                      </div>
                    ))}
                    <div className="border-border/50 col-span-2 flex h-28 transform items-center justify-center overflow-hidden rounded-2xl border bg-white/50 backdrop-blur-sm transition-all duration-300 hover:scale-105">
                      <img
                        src="/positiva.png"
                        alt="La Positiva EPS"
                        className="h-full w-full scale-150 object-contain"
                      />
                    </div>
                  </div>
                </div>

                {/* Nuestra Fundación */}
                <div className="border-primary/20 from-primary/5 to-secondary/5 rounded-2xl border bg-linear-to-r p-8">
                  <h3 className="text-foreground mb-4 flex items-center text-xl font-bold">
                    <div className="from-primary to-secondary mr-4 h-8 w-2 rounded-full bg-linear-to-b" />
                    Nuestra Fundación
                  </h3>
                  <p className="mb-4 text-base">
                    La Asociación se creó en el año <strong className="text-primary">2001</strong>{' '}
                    para facilitar el contacto entre sus entidades asociadas, canalizar sus
                    necesidades, generar sinergias y optimizar las condiciones del sector para su
                    desarrollo armónico.
                  </p>
                  <p className="text-base">
                    Con más de <strong className="text-secondary">24 años</strong>, tiene como
                    objetivo principal representar a las EPS, promoviendo prácticas y políticas que
                    ayuden a fortalecer el sector de instituciones administradoras de fondos de
                    aseguramiento en salud, en beneficio de sus más de{' '}
                    <strong className="text-primary">850 mil afiliados</strong> y de esa forma
                    contribuir con elevar los estándares de salud en el país.
                  </p>
                </div>

                {/* Nuestro Compromiso */}
                <div className="border-secondary/20 from-secondary/5 to-primary/5 rounded-2xl border bg-linear-to-r p-8">
                  <h3 className="text-foreground mb-4 flex items-center text-xl font-bold">
                    <div className="from-secondary to-primary mr-4 h-8 w-2 rounded-full bg-linear-to-b" />
                    Nuestro Compromiso
                  </h3>
                  <p className="text-base">
                    La APEPS está comprometida con la búsqueda de iniciativas que ayuden a elevar
                    continuamente los estándares de calidad que prestan sus asociadas, la
                    satisfacción de los afiliados, mejorar los procesos de gestión y atención,
                    incrementar su competitividad, incrementar el número de afiliados y{' '}
                    <strong className="text-secondary">
                      educar a la ciudadanía en la importancia del aseguramiento en salud
                    </strong>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección del Equipo */}
      <section className="relative overflow-hidden pb-20">
        <div className="via-secondary/5 absolute inset-0 bg-linear-to-b from-white to-white" />

        <div className="relative z-10 container mx-auto px-4">
          {/* Liderazgo Ejecutivo */}
          <div className="mb-16 text-center">
            <div className="bg-secondary/10 mb-6 inline-flex items-center space-x-2 rounded-full px-6 py-3 backdrop-blur-sm">
              <div className="bg-success h-3 w-3 animate-pulse rounded-full" />
              <span className="text-secondary font-semibold">Nuestro Equipo</span>
            </div>
            <h2 className="text-foreground mb-6 text-4xl font-bold md:text-5xl">
              Liderazgo{' '}
              <span className="from-secondary to-primary bg-linear-to-r bg-clip-text text-transparent">
                Ejecutivo
              </span>
            </h2>
            <p className="text-muted-foreground mx-auto max-w-3xl text-xl leading-relaxed">
              Los líderes que dirigen estratégicamente la Asociación Peruana de Entidades
              Prestadoras de Salud.
            </p>
          </div>

          {/* Grid del liderazgo */}
          <div className="mx-auto mb-20 grid max-w-4xl grid-cols-1 gap-8 md:grid-cols-2">
            {LIDERAZGO_APEPS.map(member => (
              <TeamCard key={member.nombre} member={member} />
            ))}
          </div>

          {/* Consejo Directivo */}
          <div className="mb-16 text-center">
            <h3 className="text-foreground mb-6 text-4xl font-bold md:text-5xl">
              Consejo{' '}
              <span className="from-primary to-primary/80 bg-linear-to-r bg-clip-text text-transparent">
                Directivo
              </span>
            </h3>
            <p className="text-muted-foreground mx-auto max-w-3xl text-xl leading-relaxed">
              Representantes de las principales Entidades Prestadoras de Salud que conforman APEPS.
            </p>
          </div>

          {/* Grid del consejo directivo */}
          <div className="mx-auto mb-20 max-w-7xl">
            <div className="mb-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
              {CONSEJO_DIRECTIVO.slice(0, 3).map(member => (
                <TeamCard key={member.nombre} member={member} />
              ))}
            </div>

            <div className="mx-auto grid max-w-4xl grid-cols-1 gap-8 md:grid-cols-2">
              {CONSEJO_DIRECTIVO.slice(3).map(member => (
                <TeamCard key={member.nombre} member={member} />
              ))}
            </div>
          </div>

          {/* Directores Alternos */}
          <div className="mb-16 text-center">
            <h3 className="text-foreground mb-6 text-4xl font-bold md:text-5xl">
              Directores{' '}
              <span className="from-secondary to-primary bg-linear-to-r bg-clip-text text-transparent">
                Alternos
              </span>
            </h3>
            <p className="text-muted-foreground mx-auto max-w-3xl text-xl leading-relaxed">
              Directores alternos designados por las Entidades Prestadoras de Salud que respaldan la
              labor del Consejo Directivo de APEPS.
            </p>
          </div>

          <div className="mx-auto max-w-7xl">
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {DIRECTORES_ALTERNOS.map(member => (
                <TeamCard key={member.nombre} member={member} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
